<template>
  <button
    :type="type"
    :class="`button ${generateClass} ${wrapperClass}`"
    :disabled="disabled"
    @click="click"
  >
    <div
      :class="`button__content--${
        justIcon ? 'just-icon' : 'original'
      } ${contentClass}`"
    >
      <mdicon
        v-if="rightIcon && !loading"
        class="button__right-icon d-flex"
        :name="rightIcon"
        size="20"
      />
      <span v-if="justIcon && !loading" class="button__icon">
        <mdicon :name="justIcon" size="20" class="d-flex" />
      </span>
      <span v-if="loading" class="button__icon d-flex">
        <mdicon name="loading" size="20" class="spinner" />
      </span>
      <div v-if="!justIcon && !loading" class="button__text">{{ text }}</div>
      <mdicon
        v-if="leftIcon && !loading"
        class="button__left-icon d-flex"
        :name="leftIcon"
        size="20"
      />
    </div>
  </button>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "primary",
    },
    text: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    justIcon: {
      type: String,
      default: "",
    },
    rightIcon: {
      type: String,
      default: "",
    },
    leftIcon: {
      type: String,
      default: "",
    },
    wrapperClass: {
      type: String,
      default: "",
    },
    contentClass: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
  },
  computed: {
    generateClass() {
      return `button--${this.size} button--${this.variant}`;
    },
  },
  methods: {
    click() {
      if (this.loading) return;
      this.$emit("click");
    },
  },
};
</script>
